/*
 * YoungInnovations (https://younginnovations.com.np) design tokens.
 *
 * Extracted from the live site's /themes/contrib/creative/css/app.css to
 * give the accessibility widget a brand-native look and feel.
 *
 * The site's palette is a warm, editorial system built around a deep
 * ink-navy ("primary black"), a signature orange→red gradient for
 * actions/highlights, and a soft cream paper tone for surfaces. Open Sans
 * is the display/body typeface.
 *
 * Only the subset the widget actually consumes is kept here.
 */

export const YIPL_COLORS = {
  // Brand primaries
  primaryBlack: "#181d25", // ink navy
  primaryWhite: "#f5f0e0", // warm cream
  primaryOrange: "#f26322", // signature orange
  primaryRed: "#db2e2a", // signature red (gradient partner)

  // Supporting tones used by the default widget surfaces
  gray50: "#c1c9d7",
  gray100: "#98a0ae",
  orange100: "#ffceb8",
};

/*
 * Widget theme mapping: converts the YIPL design language to the widget's
 * --acc-* runtime variables. The palette is tuned for WCAG 2.1 AA contrast
 * on the widget's own surfaces.
 */
export const YIPL_THEME = {
  // Brand core
  primaryColor: YIPL_COLORS.primaryOrange, // #f26322 signature orange
  backgroundColor: YIPL_COLORS.primaryWhite, // #f5f0e0 warm cream
  textColor: YIPL_COLORS.primaryBlack, // #181d25 ink navy (AA)

  // UI surfaces
  cardBackground: "#ffffff",
  borderColor: YIPL_COLORS.gray50, // #c1c9d7
  focusRingColor: YIPL_COLORS.primaryOrange, // #f26322
  hoverColor: YIPL_COLORS.orange100, // #ffceb8

  // Brand gradient (orange → red) and its foreground
  gradientPartnerColor: YIPL_COLORS.primaryRed, // #db2e2a gradient end
  textOnPrimary: "#ffffff", // icon/label on brand gradient

  // Header band (ink-navy) and its cream text
  headerTextColor: YIPL_COLORS.primaryWhite, // #f5f0e0

  // Neutral surfaces
  surfaceColor: "#f8f6f0", // control/button surface
  surfaceHoverColor: "#e8ded0", // empty slider track
  mutedTextColor: "#7b8494", // subtitles
  subtleTextColor: YIPL_COLORS.gray100, // #98a0ae section labels

  // Layout
  buttonSize: "52px",
  headerHeight: "68px",
  borderRadius: "14px",
  buttonBorderRadius: "12px",
  menuPosition: "",
  zIndex: 100000,

  // WCAG focus
  focusBorderWidth: "3px",
  focusOutlineOffset: "2px",
};

export default YIPL_THEME;
